<div class="flex items-center justify-center h-[80vh]">
  <div class="flex flex-col items-center px-4">
    <img
      src="assets/images/EscrowTabLogo.svg"
      class="w-auto h-32"
      alt="EscrowTab"
    />

    <!-- Post-auth bootstrap: hide the form so it cannot flash while OIDC finishes
    and AppComponent waits on GET /self. -->
    @if (completingSignIn) {
      <p class="pt-6 text-2xl font-medium text-center text-midnight">
        Signing you in…
      </p>
      <et-atoms-spinner class="mt-6"></et-atoms-spinner>
    } @else {
      <p class="pt-6 text-6xl font-bold text-center text-midnight">Welcome</p>
      @if (mobileNativeSystemBrowser) {
        <p class="pb-10 text-2xl font-medium text-center text-midnight">
          Sign in to your account
        </p>
        @if (profileLoadError) {
          <p class="mb-3 text-sm text-center text-red-600" role="alert">
            We signed you in, but couldn&apos;t load your profile. Please try
            again or contact support.
          </p>
        }
        <div class="flex justify-center">
          <button
            type="button"
            [disabled]="submitted"
            (click)="continueToSignIn()"
            class="self-center w-64 capitalize rounded-full btn btn-xl btn-primary"
            [attr.aria-busy]="submitted || null"
          >
            @if (submitted) {
              Signing in…
            } @else {
              Continue to sign in
            }
          </button>
        </div>
      } @else if (twoFactorStep) {
        <p class="pt-2 text-2xl font-medium text-center text-midnight">
          Multi-factor authentication
        </p>
        <p class="pb-10 text-base font-normal text-center text-midnight/80">
          @if (useAuthenticatorApp) {
            Enter the code from your authenticator app.
          } @else if (useBackupCode) {
            Enter one of your backup codes.
          } @else {
            Enter the MFA code we sent to verify it&apos;s you.
          }
        </p>
      } @else {
        <p class="pb-10 text-2xl font-medium text-center text-midnight">
          Sign in to your account
        </p>
      }
      @if (!mobileNativeSystemBrowser) {
        <form
          class="flex flex-col w-96 max-w-full"
          [formGroup]="form"
          (ngSubmit)="login(form.value)"
          novalidate
        >
          <et-atoms-input class="w-full">
          <label class="!bg-base-100" for="login-email">Email</label>
          <input
            id="login-email"
            class="!bg-transparent !w-full"
            etAtomsInput
            formControlName="email"
            name="email"
            type="email"
            inputmode="email"
            autocomplete="username"
            autocapitalize="none"
            autocorrect="off"
            spellcheck="false"
            autofocus
            [attr.aria-invalid]="
              form.get('email')?.touched && form.get('email')?.invalid
                ? true
                : null
            "
            [attr.aria-describedby]="
              form.get('email')?.touched && form.get('email')?.invalid
                ? 'login-email-error'
                : null
            "
          />
          @if (
            form.get('email')?.touched &&
            form.get('email')?.hasError('required')
          ) {
            <span id="login-email-error" etAtomsInputError
              >Enter your email</span
            >
          } @else if (
            form.get('email')?.touched && form.get('email')?.hasError('email')
          ) {
            <span id="login-email-error" etAtomsInputError
              >Enter a valid email</span
            >
          } @else if (
            form.get('email')?.touched &&
            form.get('email')?.hasError('isOffline')
          ) {
            <span id="login-email-error" etAtomsInputError
              >Please sign in when online</span
            >
          }
        </et-atoms-input>
        @if (showPasswordField) {
          <et-atoms-input class="relative mt-0 w-full">
            <label class="!bg-base-100" for="login-password">Password</label>
            <input
              id="login-password"
              class="!bg-transparent !w-full !pr-12"
              etAtomsInput
              formControlName="password"
              name="password"
              [type]="showPassword ? 'text' : 'password'"
              autocomplete="current-password"
              [attr.aria-invalid]="
                form.get('password')?.touched && form.get('password')?.invalid
                  ? true
                  : null
              "
              [attr.aria-describedby]="
                form.get('password')?.touched &&
                form.get('password')?.hasError('required')
                  ? 'login-password-error'
                  : null
              "
            />
            <button
              type="button"
              etAtomsInputIcon
              class="flex cursor-pointer items-center justify-center p-0 m-0 border-0 bg-transparent text-midnight/55 hover:text-midnight focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-midnight"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="
                showPassword ? 'Hide password' : 'Show password'
              "
              [attr.aria-pressed]="showPassword"
            >
              @if (showPassword) {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 h-5"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                  />
                </svg>
              } @else {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-5 h-5"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                  />
                </svg>
              }
            </button>
            @if (
              form.get('password')?.touched &&
              form.get('password')?.hasError('required')
            ) {
              <span id="login-password-error" etAtomsInputError
                >Enter your password</span
              >
            }
          </et-atoms-input>
          <a
            routerLink="/auth/forgot-password"
            class="self-end mt-2 text-sm underline normal-case text-midnight hover:text-forest-dusk focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-midnight"
            >Forgot password?</a
          >
        }
        @if (otpStep) {
          <et-atoms-input class="mt-5 w-full">
            <label class="!bg-base-100" for="login-otp"
              >Enter the code we emailed you</label
            >
            <input
              id="login-otp"
              class="!bg-transparent !w-full"
              etAtomsInput
              formControlName="otp"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              maxlength="6"
            />
          </et-atoms-input>
        }
        @if (twoFactorEnabled && twoFactorStep) {
          <et-atoms-input class="mt-5 w-full">
            <label class="!bg-base-100" for="login-otp2fa">
              @if (useAuthenticatorApp) {
                Authenticator code
              } @else if (useBackupCode) {
                Backup code
              } @else {
                MFA verification code
              }
            </label>
            <input
              id="login-otp2fa"
              class="!bg-transparent !w-full"
              etAtomsInput
              formControlName="otp2fa"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
            />
          </et-atoms-input>
        }
        @if (twoFactorStep && totpEnabled) {
          <button
            type="button"
            (click)="toggleAuthenticatorApp()"
            class="mt-2 underline normal-case btn btn-link text-midnight self-start"
          >
            {{
              useAuthenticatorApp
                ? 'Use email/text code instead'
                : 'Use an authenticator app instead'
            }}
          </button>
        }
        @if (twoFactorStep) {
          <button
            type="button"
            (click)="toggleBackupCode()"
            class="underline normal-case btn btn-link text-midnight self-start"
          >
            {{ useBackupCode ? 'Use a code instead' : 'Use a backup code instead' }}
          </button>
        }
        @if (incorrectCred) {
          <p class="mt-3 text-sm text-center text-red-600" role="alert">
            Email or password is incorrect.
          </p>
        }
        @if (incorrectCode) {
          <p class="mt-3 text-sm text-center text-red-600" role="alert">
            That code is incorrect or has expired.
          </p>
        }
        @if (genericSendError) {
          <p class="mt-3 text-sm text-center text-midnight" role="status">
            If that account exists, we&apos;ve sent a code.
          </p>
        }
        @if (incorrect2fa) {
          <p class="mt-3 text-sm text-center text-red-600" role="alert">
            That code is incorrect or has expired.
          </p>
        }
        @if (profileLoadError) {
          <p class="mt-3 text-sm text-center text-red-600" role="alert">
            We signed you in, but couldn&apos;t load your profile. Please try
            again or contact support.
          </p>
        }
        @if (accessDeniedError) {
          <p class="mt-3 text-sm text-center text-red-600" role="alert">
            Your account doesn&apos;t have access to this admin area.
          </p>
        }
        @if (!otpStep && !twoFactorStep) {
          <div class="flex justify-center mt-6">
            <button
              type="submit"
              [disabled]="submitted"
              class="self-center w-44 capitalize rounded-full btn btn-xl btn-primary"
              [attr.aria-busy]="submitted || null"
            >
              @if (submitted) {
                Signing in…
              } @else {
                {{
                  useBetterAuth && !emailLookupDone && !emailOtpEnabled
                    ? 'Continue'
                    : emailOtpEnabled || resolvedFirstFactor === 'EmailOtp'
                      ? 'Continue'
                      : 'Sign in'
                }}
              }
            </button>
          </div>
        }
        <!-- OTP mode: verify / resend / back. type="button" so Enter/click never hits the password submit. -->
        @if (otpStep) {
          <div class="flex flex-col items-center mt-6">
            <button
              type="button"
              [disabled]="submitted"
              (click)="
                submitLoginCode(
                  form.get('email')?.value,
                  form.get('otp')?.value
                )
              "
              class="w-44 capitalize rounded-full btn btn-xl btn-primary"
            >
              Verify code
            </button>
            <button
              type="button"
              (click)="sendLoginCode(form.get('email')?.value)"
              class="mt-3 underline normal-case btn btn-link text-midnight"
            >
              Resend code
            </button>
            <button
              type="button"
              (click)="backToCredentials()"
              class="underline normal-case btn btn-link text-midnight"
            >
              Back
            </button>
          </div>
        }
        <!-- 2FA mode: verify (emailed/SMS OTP) / resend / back.
            type="button" so Enter/click routes through login()'s 2FA guard, not the
            password submit. -->
        @if (twoFactorStep) {
          <div class="flex flex-col items-center mt-6">
            <button
              type="button"
              [disabled]="submitted"
              (click)="verifyTwoFactor(form.get('otp2fa')?.value)"
              class="w-44 capitalize rounded-full btn btn-xl btn-primary"
            >
              Verify
            </button>
            @if (submitted) {
              <et-atoms-spinner class="mt-3"></et-atoms-spinner>
            }
            @if (!useAuthenticatorApp && !useBackupCode) {
              <button
                type="button"
                (click)="send2faCode()"
                class="mt-3 underline normal-case btn btn-link text-midnight"
              >
                Resend code
              </button>
            }
            <button
              type="button"
              (click)="backToCredentials()"
              class="underline normal-case btn btn-link text-midnight"
            >
              Back
            </button>
          </div>
        }
        </form>
      }
      @if (deviceIsNative && !isOnline) {
        <button
          routerLink="/pincode"
          class="mt-10 underline normal-case rounded-full btn btn-link text-midnight"
        >
          Login offline
        </button>
      }
    }
  </div>
</div>

<img
  class="fixed left-0 -bottom-1 max-w-full md:-bottom-6 xl:-bottom-8 2xl:-bottom-14 -z-10"
  src="assets/images/Background-Trees.svg"
  alt=""
/>

<!-- App version -->
<p (click)="openDevTool()" class="absolute bottom-1 right-2 text-sm text-white">
  v {{ version }}
</p>
